import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const Login = () => import('@/views/Login.vue')
const UserList = () => import('@/views/user/UserList.vue')
const MerchantList = () => import('@/views/merchant/MerchantList.vue')
const NewsList = () => import('@/views/content/NewsList.vue')
const BannerList = () => import('@/views/banner/BannerList.vue')
const NavList = () => import('@/views/nav/NavList.vue')
const AdminUserList = () => import('@/views/system/AdminUserList.vue')
const SystemConfigList = () => import('@/views/system/SystemConfigList.vue')
const CustomerServiceConfig = () => import('@/views/system/CustomerServiceConfig.vue')
const OperationLogList = () => import('@/views/system/OperationLogList.vue')
const CouponCampaignList = () => import('@/views/promo/CouponCampaignList.vue')
const Dashboard = () => import('@/views/report/Dashboard.vue')
const CheckinAuditList = () => import('@/views/checkin/CheckinAuditList.vue')

const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      redirect: '/dashboard'
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard
    },
    {
      path: '/users',
      name: 'UserList',
      component: UserList
    },
    {
      path: '/merchants',
      name: 'MerchantList',
      component: MerchantList
    },
    {
      path: '/news',
      name: 'NewsList',
      component: NewsList
    },
    {
      path: '/banners',
      name: 'BannerList',
      component: BannerList
    },
    {
      path: '/navs',
      name: 'NavList',
      component: NavList
    },
    {
      path: '/system/admin-users',
      name: 'AdminUserList',
      component: AdminUserList
    },
    {
      path: '/system/configs',
      name: 'SystemConfigList',
      component: SystemConfigList
    },
    {
      path: '/system/customer-service',
      name: 'CustomerServiceConfig',
      component: CustomerServiceConfig
    },
    {
      path: '/system/logs',
      name: 'OperationLogList',
      component: OperationLogList
    },
    {
      path: '/promo/coupons',
      name: 'CouponCampaignList',
      component: CouponCampaignList
    },
    {
      path: '/checkin/audit',
      name: 'CheckinAuditList',
      component: CheckinAuditList
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    next()
    return
  }
  const token = window.localStorage.getItem('admin_token')
  if (!token) {
    next('/login')
  } else {
    next()
  }
})

export default router

